import { Component, forwardRef, OnInit } from '@angular/core';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SimulationDao } from '@app/dao/simulation/simulation.dao';
import { SimulationType } from '@app/dao/simulation/simulation.interface';
import { Subject } from 'rxjs';
import { EaSimulationLmnpFormBuilder } from './ea-simulation-lmnp-form.builder';

@Component({
    selector: 'ea-simulation-lmnp-form',
    templateUrl: './ea-simulation-lmnp-form.component.html',
    styleUrls: ['./ea-simulation-lmnp-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaSimulationLmnpFormComponent),
        },
    ],
    standalone: false
})
export class EaSimulationLmnpFormComponent
  extends EaSimulationLmnpFormBuilder
  implements OnInit
{
  doneSubject: Subject<void> = new Subject<void>();

  constructor(
    protected formConstructor: PrFormConstructor,
    private simulationDao: SimulationDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.form.get('cashOrCredit').valueChanges.subscribe(cashOrCredit => {
      if (cashOrCredit == 'CREDIT' && this.entity.loanDuration)
        this.form.get('loanDuration').setValue(this.entity.loanDuration);
      else if (cashOrCredit == 'CREDIT' && !this.form.get('loanDuration').value)
        this.form.get('loanDuration').setValue(240);
      else this.form.get('loanDuration').setValue(null);
    });
  }

  onProjectDurationChange() {
    if (
      this.form.get('loanDuration').value &&
      this.form.get('duration').value > this.form.get('loanDuration').value / 12
    ) {
      this.form
        .get('duration')
        .setValue(Math.floor(this.form.get('loanDuration').value / 12));
    }
  }

  get inCash() {
    return this.form.get('cashOrCredit').value == 'CASH';
  }

  onSubmit() {
    this.prFormService.loading();
    this.simulationDao
      .simulate(null, SimulationType.LMNP, this.extract())
      .subscribe(
        success => {
          this.prFormService.loaded();
          this.doneSubject.next();
          if (this.callback) this.callback(success);
          this.notificationService.success('La simulation a réussi');
        },
        errors => {
          console.error(errors);
          this.prFormService.loaded();
          this.notificationService.error('La simulation a échoué');
        },
      );
  }
}
